import { CartAddEvent } from '@theme/events';

document.addEventListener('click', (event) => {
  const page = event.target.closest('[data-ls-product-page]');
  if (!page) return;

  const thumb = event.target.closest('[data-ls-product-thumb]');
  if (thumb) {
    const mainImage = page.querySelector('.ls-pdp__main-image');
    if (mainImage) {
      mainImage.src = thumb.dataset.imageUrl;
      mainImage.srcset = '';
      mainImage.alt = thumb.dataset.imageAlt;
    }
    page.querySelectorAll('[data-ls-product-thumb]').forEach((button) => {
      const active = button === thumb;
      button.classList.toggle('is-active', active);
      button.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
    return;
  }

  const input = page.querySelector('input[name="quantity"]');
  if (!input) return;
  if (event.target.closest('[data-ls-quantity-minus]')) input.value = Math.max(1, Number(input.value || 1) - 1);
  if (event.target.closest('[data-ls-quantity-plus]')) input.value = Number(input.value || 1) + 1;
});

document.addEventListener('change', (event) => {
  const select = event.target.closest('[data-ls-variant-select]');
  if (!select) return;
  const page = select.closest('[data-ls-product-page]');
  page?.querySelectorAll('[data-ls-product-price]').forEach((price) => {
    price.textContent = select.selectedOptions[0].dataset.price;
  });
});

document.addEventListener('submit', async (event) => {
  const form = event.target.closest('.ls-pdp__form');
  if (!form) return;

  event.preventDefault();
  const button = form.querySelector('[type="submit"]');
  if (!button || button.disabled) return;

  const buttons = form.closest('[data-ls-product-page]').querySelectorAll('[data-ls-add-button]');
  const originalLabel = button.textContent;
  buttons.forEach((item) => { item.disabled = true; });
  button.setAttribute('aria-busy', 'true');
  button.textContent = 'Adding…';

  try {
    const formData = new FormData(form);
    const sectionIds = Array.from(document.querySelectorAll('cart-items-component[data-section-id]'))
      .map((item) => item.dataset.sectionId)
      .filter(Boolean);

    if (sectionIds.length) formData.append('sections', sectionIds.join(','));
    formData.append('sections_url', window.location.pathname);

    const response = await fetch(`${form.action}.js`, {
      method: 'POST',
      body: formData,
      headers: { Accept: 'application/json' },
    });
    const result = await response.json();
    if (!response.ok || result.status) throw new Error(result.description || 'Unable to add this item.');

    const cartResponse = await fetch('/cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' });
    const cart = cartResponse.ok ? await cartResponse.json() : {};
    document.dispatchEvent(new CartAddEvent(cart, form.id, {
      source: 'ls-product-page',
      itemCount: cart.item_count,
      sections: result.sections || {},
    }));
    button.textContent = 'Added to cart';
  } catch (error) {
    button.textContent = error.message || 'Try again';
  } finally {
    window.setTimeout(() => {
      buttons.forEach((item) => { item.disabled = false; });
      button.removeAttribute('aria-busy');
      button.textContent = originalLabel;
    }, 1400);
  }
});

function setupStickyPurchase(root = document) {
  root.querySelectorAll('[data-ls-product-page]').forEach((page) => {
    const bar = page.querySelector('[data-ls-sticky-buy]');
    const form = page.querySelector('.ls-pdp__form');
    const purchaseButton = form?.querySelector('[data-ls-add-button]');
    const footer = document.querySelector('footer');
    if (!bar || !purchaseButton || bar.dataset.initialized) return;
    bar.dataset.initialized = 'true';
    let formVisible = true;
    let footerVisible = false;
    const update = () => { bar.hidden = formVisible || footerVisible; };
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.target === purchaseButton) formVisible = entry.isIntersecting;
        if (entry.target === footer) footerVisible = entry.isIntersecting;
      });
      update();
    });
    observer.observe(purchaseButton);
    if (footer) observer.observe(footer);
    document.addEventListener('shopify:section:unload', (event) => {
      if (event.target.contains(page)) observer.disconnect();
    }, { once:true });
  });
}
setupStickyPurchase();
document.addEventListener('shopify:section:load', (event) => setupStickyPurchase(event.target));
